module.exports = __webpack_public_path__ + "img/digital-tahavol.41b8d94.svg";